import axios from "axios";
import { baseUrl } from "./baseUrl";

const ForgetPasswordFunc = () => {
  const postResetEmail = (data) => {
    let config = {
      method: "post",
      maxBodyLength: Infinity,
      url: `${baseUrl}/users/forgot-password`,
      data: data,
    };

    return axios.request(config);
  };

  const updatePass = (data) => {
    let config = {
      method: "post",
      maxBodyLength: Infinity,
      url: `${baseUrl}/users/reset-password`,
      data: data,
    };

    return axios.request(config);
  };

  const verifyEmail = (data) => {
    let config = {
      method: "post",
      maxBodyLength: Infinity,
      url: `${baseUrl}/users/verify-email`,
      data: data,
    };

    return axios.request(config);
  };

  const reqDeleteAccount = (data) => {
    let config = {
      method: "post",
      maxBodyLength: Infinity,
      url: `${baseUrl}/users/delete`,
      data: data,
    };

    return axios.request(config);
  };

  const confirmDeleteAccount = (data) => {
    let config = {
      method: "post",
      maxBodyLength: Infinity,
      url: `${baseUrl}/users/confirmDelete`,
      data: data,
    };

    return axios.request(config);
  };

  return {
    postResetEmail,
    updatePass,
    verifyEmail,
    reqDeleteAccount,
    confirmDeleteAccount,
  };
};

export default ForgetPasswordFunc;
